/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-11T09:27:30.384
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportFinancialStorageContractPlan,
	getReportFinancialStorageContractPlanCreateInit,
	getReportFinancialStorageContractPlanEditInit,
	getReportFinancialStorageContractPlanView,
	deleteReportFinancialStorageContractPlan
} from '@api/report/ReportFinancialStorageContractPlan';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportFinancialStorageContractPlanCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractPlanCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportFinancialStorageContractPlanEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractPlanEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportFinancialStorageContractPlan({}, ReportFinancialStorageContractPlan) {
			return new Promise((resolve, reject) => {
				saveReportFinancialStorageContractPlan(ReportFinancialStorageContractPlan)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportFinancialStorageContractPlanView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractPlanView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportFinancialStorageContractPlan({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialStorageContractPlan({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
